// path -> sinaliza se estara disponivel em rota especifica ou globalmente
// max-age -> define tempo de vida negativo, fazendo o browser deletar imediatamente

/**
 * @name removeCookieLPlus
 * @description Remove o cookie de refresh_token utilizado para autenticação do widget Leadster Plus, 
 * efetivamente negando acesso ao widget e forçando nova autenticação em futuras tentativas de acesso.
 * Deve ser chamado durante o processo de logout ou quando ocorrer um erro crítico de autenticação.
 * @returns {void}
 */
export const removeCookieLPlus = () => {
  document.cookie = "refresh_token=; max-age=-1; path=/;";
};

/**
 * @name addCookieLPlus
 * @description Adiciona o cookie de refresh_token utilizado para autenticação do widget Leadster Plus, 
 * permitindo acesso ao widget em futuras tentativas de acesso. Deve ser chamado após a obtenção de um novo refresh_token.
 * @param {string} refresh_token - O token de atualização a ser armazenado no cookie.
 * @returns {void}
 */
export const addCookieLPlus = (refresh_token) => {
  document.cookie = `refresh_token=${refresh_token}; path=/;`;
};
